import { sysURL } from '../constants';
import { httpClient } from './../utils/HttpClient';
import * as M from '../reducers/settingLabel.reducer';

//redirect to login page

//load Count Summary Data Group ";
export const setSettingLabelStateToFetching = () => ({
  type: M.SETTING_LABEL_FETCHING,
});

export const setSettingLabelStateToFailed = () => ({
  type: M.SETTING_LABEL_FAILED,
});

export const setSettingLabelStateToSuccess = (payload) => ({
  type: M.SETTING_LABEL_SUCCESS,
  payload,
});

export const loadSettingLabel = ({
  columnOrder,
  isAscending,
  pageNo,
  perPage,
  search,
}) => {
  let api = 'label/v1/getListAllPaging';
  let url = api;
  return async (dispatch, getState) => {
    try {
      dispatch(setSettingLabelStateToFetching());

      let result = await httpClient.post(url, {
        perPage: perPage,
        pageNo: pageNo,
        columnOrder: columnOrder,
        isAscending: isAscending,
        search: search,
      //  searchObj: search,
      });

      if (result.data.status == true) {
        dispatch(setSettingLabelStateToSuccess(result.data));
      } else {
        dispatch(setSettingLabelStateToFailed([]));
      }

    } catch (error) {
      console.log(error);
      dispatch(setSettingLabelStateToFailed({ data: { message: error } }));
    }

    return getState().SettingLabelReducer.result.content;
  };
};

//delete data ";
export const setSettingLabelDeleteStateToFetching = () => ({
  type: M.SETTING_LABEL_DELETE_FETCHING,
});

export const setSettingLabelDeleteStateToFailed = () => ({
  type: M.SETTING_LABEL_DELETE_FAILED,
});

export const setSettingLabelDeleteStateToSuccess = (payload) => ({
  type: M.SETTING_LABEL_DELETE_SUCCESS,
  payload,
});

export const deleteSettingLabel = (data) => {
  let api = 'label/v1/' + data;
  let url = api;
  return async (dispatch) => {
    try {
      dispatch(setSettingLabelDeleteStateToFetching());

      let result = await httpClient.delete(url);

      if (result.data.status == true) {
        dispatch(setSettingLabelDeleteStateToSuccess(result.data));
      } else {
        dispatch(setSettingLabelDeleteStateToFailed([]));
      }
    } catch (error) {
      console.log(error);
      dispatch(
        setSettingLabelDeleteStateToFailed({ data: { message: error } })
      );
    }

    // return getState().SettingPermissionReducer.result.content;
  };
};
